export default {
  SMELL: 'smell', // มีกลิ่น
  GINGIVITIS: 'gingivitis', // เหงือกอักเสบ
  DENTAL_CALCULUS: 'detal calculas', // หินปูน
  DECAYED_TOOTH: 'decayed tooth' // ฟันผุ
}
